import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Sidebar } from "../Global/Atomics/SideBar";
import styled from "styled-components";
import Theme from "../../styles/Theme/Theme";
import { AnalyticWarper } from "../Global/Organism/Analytic/AnalyticWarper";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
  background-color: ${Theme.color["neutral-1"]};
`;

const RightContent = styled.div`
 display:flex;
 flex-direction:column;
 justify-content:space-between;
  width: calc(100% - 235px);
  overflow-y:auto;
  .tab_component_children {
    padding: ${Theme.spacing.s05};
    box-sizing: border-box;
  }
`;

const AnalyticSideBar = [
  {
    name: "Facilities",
    label: "facilities",
    path: "#facilities"
  },
  {
    name: "IP",
    label: "ip",
    path: "#ip",
    submenus: null
  },
  {
    name: "PTD",
    label: "ptd",
    path: "#ptd"
  }
];

export const Analytic = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(null);
  const [disableSideBar, setDisableSideBar] = useState(false);

  // UseEffect para sincronizar o hash com o estado
  useEffect(() => {
    const hash = location.hash.replace("#", "") || "facilities"; // Fallback para "ip"
    setCurrentTab(hash);
  }, [location.hash]);

  const blockSideBar = (bool) => {
    setDisableSideBar(bool);
  };

  const getComponentByTab = () => {
    if (currentTab === "ip") {
      return <AnalyticWarper classes="Street Lighting" tableConfigurations={ipTableConfigurations(t)} currentTab={currentTab} blockSideBar={blockSideBar}/>;
    } else if (currentTab === "ptd") {
      return <AnalyticWarper classes="Distribution Transformer Station" tableConfigurations={ipTableConfigurations(t)} currentTab={currentTab} blockSideBar={blockSideBar}/>;
    } else if (currentTab === "facilities") {
      return <AnalyticWarper classes="not_Street Lighting" types="Buildings,Infrastructures" tableConfigurations={facilitiesTableConfigurations(t)} currentTab={currentTab} blockSideBar={blockSideBar}/>;
    }
    return null;
  };

  const OpenTabComponent = getComponentByTab();

  return (
    <Wrapper>
      <Sidebar
        sideBarMenu={AnalyticSideBar}
        activeTab={currentTab}
        setCurrentTab={setCurrentTab}
        disableSideBar={disableSideBar}
      />
      <RightContent key={currentTab}>
        {/* Like this the filters are not mantined when changing tabs */}
        {OpenTabComponent}
      </RightContent>
    </Wrapper>
  );
}

const ipTableConfigurations = (t) => {
  return {
      collumnsConfiguration: [
          {
              "title": t('name'),
              "dataIndex": "name",
              "key": "name"
          },
          {
              "title": t("Typology"),
              "dataIndex": "class",
              "key": "class",
              "filterMultipleSelect": true
          },
          {
              "title": t("Address"),
              "dataIndex": "address",
              "key": "address"
          },
          {
              "title": t("Entity/Subentity"),
              "dataIndex": "tenant",
              "key": "tenant",
              "filterMultipleSelect": true
          },
          {
              "title": t("Voltage Level"),
              "dataIndex": "voltageLevel",
              "key": "voltageLevel",
              "filterMultipleSelect": true
          },
          {
              "title": t("Contracted Power") + " (kVA)",
              "dataIndex": "contractedPower",
              "key": "contractedPower",
              "filterMultipleSelect": true
          },
          {
              "title": t("Municipality-Parish"),
              "dataIndex": "location",
              "key": "location",
              "filterMultipleSelect": true
          }
      ],
      hideSelectAll: false
  }
};

const facilitiesTableConfigurations = (t) => {
  return {
      collumnsConfiguration: [
          {
              "title": t('name'),
              "dataIndex": "name",
              "key": "name"
          },
          {
              "title": t("Typology"),
              "dataIndex": "class",
              "key": "class",
              "filterMultipleSelect": true
          },
          {
              "title": t("Address"),
              "dataIndex": "address",
              "key": "address"
          },
          {
              "title": t("Entity/Subentity"),
              "dataIndex": "tenant",
              "key": "tenant",
              "filterMultipleSelect": true
          },
          {
              "title": t("Voltage Level"),
              "dataIndex": "voltageLevel",
              "key": "voltageLevel",
              "filterMultipleSelect": true
          },
          {
              "title": t("Contracted Power") + " (kVA)",
              "dataIndex": "contractedPower",
              "key": "contractedPower",
              "filterMultipleSelect": true
          },
          {
              "title": t("Municipality-Parish"),
              "dataIndex": "location",
              "key": "location",
              "filterMultipleSelect": true
          },
          {
              "title": t("Energy Certificate"),
              "dataIndex": "energyCertificate",
              "key": "energyCertificate",
              "filterMultipleSelect": true
          },
          {
              "title": t("Gas"),
              "dataIndex": "gas",
              "key": "gas",
              "filterMultipleSelect": true
          },
          {
              "title": t("Energy Production"),
              "dataIndex": "energyProduction",
              "key": "energyProduction",
              "filterMultipleSelect": true
          }
      ],
      hideSelectAll: false
  }
};